<template>
    <div>

      <div class="box"  v-if="showQrCodeDialog">
        
        <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;">
            <div style="text-align: end; padding-right: 20px; padding-top: 10px; font-size: 26px; position: absolute;  right: 18px;" @click="AddexportBtnssShowCler"><i class="el-icon-close"></i> </div>
            <div style="font-size:20px;font-weight: 900;margin-bottom: 10px;margin-bottom:20px; margin-top: 24px;">{{ title_new }}</div>

            <el-row style="margin-bottom: 10px;"  >
                <el-col :span="12" style="display: flex;justify-content: space-evenly;">
                    <div style="display: flex;margin-top: -10px;">
                        <span style="padding-top: 10px;margin-left: -63px;margin-right: 8px;">问卷标题:</span>
                        <span><el-input v-model="title"  placeholder="请输入问卷标题" style="width: 400px;"></el-input></span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div style="display: flex;justify-content: start;margin-left: 43px;">
                        <div style="width:100px;">问卷描述:</div>
                        <div style="margin-left: 10px;margin-top: -8px;">
                            <el-input type="textarea"  autosize  placeholder="请输入问卷描述"  style="width: 500px;"  v-model="content">  </el-input>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>


        <div style="display: flex;margin-top: 10px;">
            <div style="width:8%;height: 87vh; border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px; margin-right: 10px; margin-left: 10px;">
                <div style="width: 100%;display: flex;flex-wrap: wrap;"  >
                    <div class="actdiv" style="width: 50%;margin-top: 10px; margin-left: 10px;padding: 10px 20px;"  @click="handleAddAnswers(1)">填空题</div>
                </div>
                <div style="width: 100%;display: flex;flex-wrap: wrap;"  >
                    <div class="actdiv" style="width: 50%;margin-top: 10px; margin-left: 10px;padding: 10px 20px;"  @click="handleAddAnswers(2)">单选题</div>
                </div>
                <div style="width: 100%;display: flex;flex-wrap: wrap;"  >
                    <div class="actdiv" style="width: 50%;margin-top: 10px; margin-left: 10px;padding: 10px 20px;"  @click="handleAddAnswers(3)">多选题</div>
                </div>
            </div>

            <div style="width:100%;height: 87vh;border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;overflow: auto;">
                <el-card style="width: 98%;border-radius: 20px;margin-left: 23px;margin-top: 10px;margin-right: 12px; " v-for="(itme,index) in QuestionnaireViewLsit" :key="index"   :style="index === QuestionnaireViewLsit.length - 1 ? 'margin-bottom: 60px;' : ''">

                    <div style="margin-left:20px;">
                        <div style="font-size: 26px;padding-top: 1px;text-align: end; width: 100%;display: flex; justify-content: justify;">
                            <div style="font-size: 15px; margin-right: 10px; width: 50%;">{{ itme.tepy === 1 ? '填空题' : itme.tepy === 2 ? '单选题' : '多选题' }}</div>
                            <i style="width: 50%;" class="el-icon-remove-outline" v-if="(itme.text === '咱们家是男孩还是女孩?' || (itme.text === '您目前居住的城区是?' || itme.text === '属于地域?') || itme.text === '孩子名字是什么?' || itme.text === '目前是几年级?') ? false : true" @click="handleFreeformQuestionsReduce(index)"  ></i>
                        </div>
                    </div> 


                    <div  v-if="itme.tepy === 1 || itme.tepy === 6" style="margin-top: 40rpx; ">
                        <div style="display: flex; margin-top: 12px;">
                            <div  style="font-size:  14px; color: #9a9696; margin-top: 7px;  margin-right: 10px; " >{{ index + 1 }}.</div>
                            <el-input type="textarea" class="type_1" autosize  placeholder="请输入题目"  v-model="itme.text" :disabled="itme.text === '孩子名字是什么?' ? true : itme.text === '目前是几年级?' ? true : false">  </el-input>
                        </div>
                        <!-- <el-input type="text" style="margin-left: -66px;"  class="type_1" v-model="itme.input" :placeholder="itme.placeholderText" :disabled="true"></el-input> -->
                    </div>


                    <div  v-if="itme.tepy === 2" style="margin-top: 40rpx; ">
                        <div style="display: flex; margin: 17px 0px;">
                            <div  style="font-size:  14px; color: #9a9696; margin-top: 7px;  margin-right: 10px;" >{{ index + 1 }}.</div>
                            <el-input type="textarea" class="type_1" autosize  placeholder="请输入题目"  v-model="itme.text" :disabled="itme.text === '咱们家是男孩还是女孩?' ? true : (itme.text === '您目前居住的城区是?' || itme.text === '属于地域?') ? true : false">  </el-input>
                        </div>
                        <div style="display: flex;margin-left: 40px;margin-top: 30px;height: 87px;">
                            <div style="width: 90%;display: flex;flex-wrap: wrap;overflow: auto;height: 100px;width: 100%; margin-left: -50px;">
                                <div style="display: flex;margin-bottom: 14px;" v-for="(itmesm,indexs) in itme.typeList" :key="indexs">
                                    <div style="width: 45px;margin-right: -8px;margin-left: 20px;margin-top: 11px;">{{ itmesm.type }}：</div>
                                    <div>
                                        <el-input v-model="itmesm.name" :disabled="itme.text === '咱们家是男孩还是女孩?' ? true : (itme.text === '您目前居住的城区是?' || itme.text === '属于地域?') ? true : false"></el-input> 
                                    </div>
                                    <div v-if="index > 3" style="margin: 10px;">
                                        <el-switch v-model="itmesm.switch" active-text="填空" inactive-text=""></el-switch>
                                    </div>
                                </div>
                            </div>
                            <div style="margin-left:20px;">
                                <div style="font-size: 26px;padding-top: 1px; display: flex;">
                                    <i v-if="itme.text === '咱们家是男孩还是女孩?' ? false : (itme.text === '您目前居住的城区是?' || itme.text === '属于地域?') ? false : true" class="el-icon-circle-plus-outline" @click="handleMultipleChoiceQuestionType('+',index)" style="color: #17a5e3;"></i>
                                    <i v-if="itme.text === '咱们家是男孩还是女孩?' ? false : (itme.text === '您目前居住的城区是?' || itme.text === '属于地域?') ? false : true" class="el-icon-remove-outline" @click="handleMultipleChoiceQuestionType('-',index)" style="color: #17a5e3;margin-left: 10px;"></i>
                                </div>
                            </div> 
                        </div>
                    </div>


                    <div  v-if="itme.tepy === 3" style="margin-top: 40rpx; ">
                        <div style="display: flex; margin-top: 12px;">
                            <div  style="font-size:  14px; color: #9a9696; margin-top: 7px;  margin-right: 10px;" >{{ index + 1 }}.</div>
                            <el-input type="textarea" class="type_1" autosize  placeholder="请输入题目"  v-model="itme.text">  </el-input>
                        </div>
                        <div style="display: flex;margin-left: 40px;margin-top: 30px;height: 87px;">
                            <div style="width: 90%;display: flex;flex-wrap: wrap;overflow: auto;height: 100px;width: 100%; margin-left: -50px;">
                                <div style="display: flex;margin-bottom: 14px;" v-for="(itmesm,indexs) in itme.typeList" :key="indexs">
                                    <div style="width: 45px;margin-right: -8px;margin-left: 20px;margin-top: 11px;">{{ itmesm.type }}：</div>
                                    <div>
                                        <el-input v-model="itmesm.name"></el-input> 
                                    </div>
                                    <div v-if="index > 3" style="margin: 10px;">
                                        <el-switch v-model="itmesm.switch" active-text="填空" inactive-text=""></el-switch>
                                    </div>
                                </div>
                            </div>
                            <div style="margin-left:20px;">
                                <div style="font-size: 26px;padding-top: 1px; display: flex;">
                                    <i class="el-icon-circle-plus-outline" @click="handleMultipleChoiceQuestionType('+',index)" style="color: #17a5e3;"></i>
                                    <i class="el-icon-remove-outline" @click="handleMultipleChoiceQuestionType('-',index)" style="color: #17a5e3;margin-left: 10px;"></i>
                                </div>
                            </div> 
                        </div>
                    </div>

                    
                </el-card>

                <div v-if="QuestionnaireViewLsit && QuestionnaireViewLsit.length === 0" style="display: flex; width: 100%;  justify-content: center;  margin-top: 12%;">
                    <el-empty :image-size="200"></el-empty>
                </div>
            </div>

        </div>

        <div slot="footer" class="dialog-footer" style="position: fixed;bottom: 46px; right: 30px;display: flex; ">
            <el-button size="small" class="btns" @click="AddexportBtnssShowCler">关闭</el-button>
            <el-button size="small" class="btns" @click="AddexportBtnssShowAdd">提交</el-button>
        </div>

      </div>


    </div>
</template>



<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";


export default {
    name: 'AddQuestionnaireComonmte',
    props: {
        titles: {
            type: String,
            default: '添加问卷'
        },
        itmes: {
            type: Object,
            default: () => ({})
        },
    },
    data() {
        return {
            showQrCodeDialog: false,
            title_new:'',


            title:'',
            content:'',
            QuestionnaireViewLsit:[],

        }
    },

    mounted() {
       this.showQrCodeDialog = true
       this.title_new = this.titles

       if(this.title_new === '添加问卷'){
            this.QuestionnaireViewLsit = [
                
                {
                   text:'您目前居住的城区是?' ,
                   tepy:2 ,
                   input:'',
                   typeList:[
                       { name: '东城',  type:'A', activation: 0, switch: false, switchinput: '',},
                       { name: '西城',  type:'B', activation: 0, switch: false, switchinput: '',},
                       { name: '朝阳',  type:'C', activation: 0, switch: false, switchinput: '',},
                       { name: '海淀',  type:'D', activation: 0, switch: false, switchinput: '',},
                       { name: '丰台',  type:'E', activation: 0, switch: false, switchinput: '',},
                       { name: '石景山',  type:'F', activation: 0, switch: false, switchinput: '',},
                       { name: '其他',  type:'G', activation: 0, switch: true, switchinput: '',}
                   ]
                },
                {
                   text:'咱们家是男孩还是女孩?' ,
                   tepy:2 ,
                   input:'',
                   typeList:[
                       { name: '男孩',  type:'A', activation: 0 },
                       { name: '女孩',  type:'B', activation: 0 },
                   ]
                },
                { 
                  text: '孩子名字是什么?',
                  tepy: 1,
                  placeholderText: '请输入内容',
                  input: '',
                  typeList: []
                },
                { 
                  text: '目前是几年级?',
                  tepy: 6,
                  placeholderText: '请输入内容',
                  input: '',
                  typeList: []
                },
            ]

       }else{
         this.handleInit()
       }
    },

    methods: {

        handleInit(){
            this.title = this.itmes.titleName ? this.itmes.titleName : ''
            this.content = this.itmes.describeInfo ? this.itmes.describeInfo : ''
            this.QuestionnaireViewLsit = this.itmes.content ? this.itmes.content : []
        },


        handleAddAnswers (type){
           if(type === 1){
               this.QuestionnaireViewLsit.push(
                   { 
                     text: '',
                     tepy: 1,
                     placeholderText: '请输入内容',
                     input: '',
                     typeList: []
                   }
               )
           }else if(type === 2){
               this.QuestionnaireViewLsit.push(
                 {
                    text:'' ,
                    tepy:2 ,
                    input:'',
                    typeList:[
                        { name: '',  type:'A', activation: 0, switch: false, switchinput: '',}
                    ]
                 }
               )
           }else if(type === 3){
               this.QuestionnaireViewLsit.push(
                    {
                        text: '',
                        tepy: 3,
                        placeholderText: '请选择',
                        input: '',
                        typeList: [
                            { name: '', type:'A', activation: 0, switch: false, switchinput: '',},
                        ],
                    }
               )
           }
       
        },


        handleMultipleChoiceQuestionType(type,index){
            if(type === '+'){
                const currentLength = this.QuestionnaireViewLsit[index].typeList.length;
                const newType = String.fromCharCode(65 + currentLength);
                this.QuestionnaireViewLsit[index].typeList.push(
                    { 
                      name: '',
                      type: newType , 
                      activation: 0,
                      switch: false,
                      switchinput: '',
                    }
                )
            }else if(type === '-'){
                 this.QuestionnaireViewLsit[index].typeList.pop();

            }
        },


        handleFreeformQuestionsReduce(index){
            let result = this.deleteByIndex(this.QuestionnaireViewLsit, index)
            this.QuestionnaireViewLsit = result
            
        },

        deleteByIndex (arr, index){
            arr.splice(index, 1)
            return arr
        },

        AddexportBtnssShowCler() {
            this.$emit('handleColes')
        },


        AddexportBtnssShowAdd() {
            if(this.content && this.title){
                const data = { id: this.itmes.id , describeInfo: this.content,   titleName: this.title,   content: this.QuestionnaireViewLsit && this.QuestionnaireViewLsit.length > 0 ? JSON.stringify(this.QuestionnaireViewLsit) : '' }
              
                let url = this.itmes.id ? `${apiBaseUrl}/questionnaireTemplate/update` : `${apiBaseUrl}/questionnaireTemplate/add`

                axios.post(`${url}`, data, { headers:{  'authorization': sessionStorage.getItem('tokenInfo')  } }).then((res)=>{
                        if(res.data.code == 200){
                             this.$message.success(res.data.message || '修改成功')
                             this.$emit('handleColes')
                        }else{
                            this.$message.error(res.data.message || '提交失败')
                        }
                }).catch((error)=>{
                    this.$message.error(error)
                })
            }else{
                this.$message({ message: '请输入（问卷标题 & 问卷描述）',  type: 'warning'   });
            }
            
        },

    },

}

</script>


<style  lang="less" scoped>
   .box{
        position: fixed;
        background: #f3f3f3;
        width: 100%;
        z-index: 1111;
        top: 0;
        left: 0;
        height: 100vh;
        margin: 0;
    }

    .actdiv:hover{
       border-radius: 30px;
       background: #428BCA;      
       color: #fff;
       padding: 5px 0px;
    }

    .btns{
        background-color: #428BCA;
        color: #fff;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-left: 10px;
    }

    .type_1{
        margin: 15px 0px;
        background-color: #f7f8f9;
        width: 92%; 
        height: 100rpx;
        margin-left: 1%;
        border-radius: 10rpx;
        margin-top: 10rpx;
        padding-left: 20rpx
    }

</style>


// WEBPACK FOOTER //
// src/customerManagement/AddQuestionnaireComonmte.vue